import { CheckIcon } from '../../../../components/ReusableComponents/Icons/Check'
import { CrossIcon } from '../../../../components/ReusableComponents/Icons/Cross'
import { Cell } from '../../../../components/ReusableComponents/Table/index'
import styles from './CheckCell.module.scss'

const GreenCheck = () => <CheckIcon className={styles.greenCheck} />
const GrayCross = () => <CrossIcon className={styles.grayCross} />

const CheckCell = ({ isChecked = false, ...props }) => (
  <Cell className={styles.checkCell} {...props}>
    {isChecked ? <GreenCheck /> : <GrayCross />}
  </Cell>
)

export default CheckCell
